<template>
    <v-dialog ref="dialog" v-model="value" persistent :max-width="maxWidth">
        <v-card>         
            <v-card-title>
                <span class="headline">{{title}}</span>
            </v-card-title>

            <v-card-text>
                <v-form ref="form">
                    <slot></slot>
                </v-form>
            </v-card-text> 

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="danger" @click="$emit('input', false)">{{cancel}}</v-btn>                             
                <v-btn color="success" @click="btnConfirm_OnClick">{{confirm}}</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>  
</template>

<script>
import FormMixin from '@/mixin/form'

export default {
    name: "form-dialog", 
    mixins: [ FormMixin ],  
    props:{
        confirm_OnClick:{
            required: false, 
            type: Function
        },                    
        maxWidth:{
            required: false, 
            default: "1000px",
            type: String          
        },
        title:{
            required: true, 
            type: String
        },
        value:{
            required: false,
            type: [Boolean]
        }
    },
    computed: {  
        cancel () {
            return this.$t("Common.cancel");
        },     
        confirm () {
            return this.$t("Common.confirm");
        }, 
        loadingText () {
            return this.$t("Common.loading");
        },
    },   
    methods:{     
        async btnConfirm_OnClick(){
            if(this.$refs.form.validate()){
                if(this.confirm_OnClick != undefined && this.confirm_OnClick != null){
                    await this.confirm_OnClick();
                }

                this.$emit("input", false);
            }
        }       
    }
}
</script>

<style lang="scss">
@import "../../styles/material-dashboard/variables";

.picklist{
    background-color: #FFF !important;
}

.search-activator{
    .v-input__control{
        .v-input__append-inner{
            i{
                color: $brand-primary !important; 
            }
        }
    }
    .v-input__append-outer{
        i{
            color: $brand-danger !important; 
        }
    }
}

.v-data-table{
    tbody{
        tr:hover{
            cursor: pointer;
        }
    }
}
</style>
